import './main.css';
import { createBrowserRouter, RouterProvider, Outlet, Navigate } from 'react-router-dom';

import LoginAdmin from './pages/LoginAdmin/LoginAdmin';
import Sidebar from './components/Sidebar/Sidebar';
import Navbar from './components/Navbar/Navbar';
import AgentList from './pages/AgentList/AgentList';
import AgentLimitPage from './pages/AgentLimitPage/AgentLimitPage';
import UserLimitPage from './pages/UserLimitPage/UserLimitPage';
import CustomerLimitPage from './pages/CustomerLimitPage/CustomerLimitPage';
import MyRequestsPage from './pages/MyRequestsPage/MyRequestsPage';
import PendingRequestsPage from './pages/PendingRequestsPage/PendingRequestsPage';
import TransactionReportPage from './pages/TransactionReportPage/TransactionReportPage';
import RevenueReportPage from './pages/RevenueReportPage/RevenueReportPage';
import AgentReportPage from './pages/AgentReportPage/AgentReportPage';

import ToastContainer from './components/Toast/ToastContainer';


// Layout cho app sau đăng nhập
const DashboardLayout = () => (
  <div className="dashboard-wrapper">
    <Navbar />
    <div className="main-area">
      <Sidebar />
      <div className="page-content">
        <Outlet />
      </div>
    </div>
  </div>
);

// Layout rỗng cho login
const EmptyLayout = () => (
  <div>
    <Outlet />
  </div>
);

const App = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <EmptyLayout />,
      children: [
        { path: '/', element: <LoginAdmin /> },
      ],
    },

    {
      path: '/app',
      element: <DashboardLayout />,
      children: [
        { path: '/app/agents', element: <AgentList /> },

        // TRUY VẤN
        { path: 'queries/agent-limit', element: <AgentLimitPage /> },
        { path: 'queries/user-limit', element: <UserLimitPage /> },
        { path: 'queries/customer-limit', element: <CustomerLimitPage /> },

        // PHIẾU YÊU CẦU
        { path: 'requests/mine', element: <MyRequestsPage /> },
        { path: 'requests/pending', element: <PendingRequestsPage /> },

        // BÁO CÁO
        { path: 'reports/transactions', element: <TransactionReportPage /> },
        { path: 'reports/revenue', element: <RevenueReportPage /> },
        { path: 'reports/agents', element: <AgentReportPage /> },
      ],
    },

    { path: '*', element: <Navigate to="/" replace /> },
  ]);

  return (
    <ToastContainer>
      <RouterProvider router={router} />
    </ToastContainer>
  );
};

export default App;
